export const CashOutCountriesList = {
  ARGENTINA: 'AR',
  BRAZIL: 'BR',
  COTEDIVOIRE: 'CI',
  CANADA: 'CA',
  CHILE: 'CL',
  CAMEROOM: 'CM',
  CHINA: 'CN',
  COLOMBIA: 'CO',
  ECUADOR: 'EC',
  GHANA: 'GH',
  INDONESIA: 'ID',
  INDIA: 'IN',
  KENYA: 'KE',
  MEXICO: 'MX',
  MALAYSIA: 'MY',
  NIGERIA: 'NG',
  PANAMA: 'PA',
  PERU: 'PE',
  PHILIPPINES: 'PH',
  THAILAND: 'TH',
  TANZANIA: 'TZ',
  UGANDA: 'UG',
  URUGUAY: 'UY',
  VIETNAM: 'VN',
  DOMINICAN_REPUBLIC: 'DO',
  JAPAN: 'JP',
};

class CashOutCountriesValidator {
  constructor(country) {
    this.country = country;
  }

  country = null;

  only = (...countries) => {
    return countries.includes(this.country);
  };

  except = (...countries) => {
    return !countries.includes(this.country);
  };
}

export const cashOutValidatorResult = (country) => {
  const validator = new CashOutCountriesValidator(country);
  return {
    bankCode: validator.except(CashOutCountriesList.ARGENTINA, CashOutCountriesList.MEXICO, CashOutCountriesList.INDIA, CashOutCountriesList.PERU),
    bankBranch: validator.only(CashOutCountriesList.BRAZIL, CashOutCountriesList.INDIA),
    bankAccountType: validator.except(
      CashOutCountriesList.ARGENTINA,
      CashOutCountriesList.CAMEROOM,
      CashOutCountriesList.GHANA,
      CashOutCountriesList.INDIA,
      CashOutCountriesList.INDONESIA,
      CashOutCountriesList.KENYA,
      CashOutCountriesList.MALAYSIA,
      CashOutCountriesList.MEXICO,
      CashOutCountriesList.NIGERIA,
      CashOutCountriesList.PHILIPPINES,
      CashOutCountriesList.TANZANIA,
      CashOutCountriesList.THAILAND,
      CashOutCountriesList.UGANDA,
      CashOutCountriesList.VIETNAM,
      CashOutCountriesList.CHINA,
      CashOutCountriesList.CANADA
    ),
    clientLastName: validator.only(
      CashOutCountriesList.ARGENTINA,
      CashOutCountriesList.COLOMBIA,
      CashOutCountriesList.CAMEROOM,
      CashOutCountriesList.COTEDIVOIRE,
      CashOutCountriesList.ECUADOR,
      CashOutCountriesList.GHANA,
      CashOutCountriesList.INDONESIA,
      CashOutCountriesList.KENYA,
      CashOutCountriesList.MALAYSIA,
      CashOutCountriesList.MEXICO,
      CashOutCountriesList.NIGERIA,
      CashOutCountriesList.PANAMA,
      CashOutCountriesList.PERU,
      CashOutCountriesList.PHILIPPINES,
      CashOutCountriesList.TANZANIA,
      CashOutCountriesList.THAILAND,
      CashOutCountriesList.UGANDA,
      CashOutCountriesList.VIETNAM,
      CashOutCountriesList.DOMINICAN_REPUBLIC
    ),
    clientDocumentType: validator.only(CashOutCountriesList.PERU, CashOutCountriesList.COLOMBIA, CashOutCountriesList.PANAMA, CashOutCountriesList.DOMINICAN_REPUBLIC),
    clientAddress: validator.only(CashOutCountriesList.COLOMBIA),
    clientEmail: validator.only(CashOutCountriesList.COLOMBIA),
    clientPhone: validator.only(CashOutCountriesList.INDIA),
    bankAccount: validator.except(CashOutCountriesList.CANADA, CashOutCountriesList.COLOMBIA),
  };
};

export const fieldsRequiredByCountry = (country, schema, msg) => {
  const validator = cashOutValidatorResult(country);
  Object.keys(schema).forEach((field) => {
    if (validator[field]) schema[field] = schema[field].required(msg);
  });
  return schema;
};

export const cashOutFieldsRequired = (country) => {
  const cashOutValidator = cashOutValidatorResult(country);
  return Object.keys(cashOutValidator).reduce((ret, key) => {
    return [...ret, ...(cashOutValidator[key] ? [key] : [])];
  }, []);
};
